import { DefaultError } from '@tanstack/react-query';
import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { userFormInitialValues } from 'components/organisms/forms/client-user/ClientUserForm';
import { FormikHelpers } from 'formik';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiVinylRecord, PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  useDisableTwoFactor,
  useEnableTwoFactor,
} from 'services/auth/disableTwoFactor';
import {
  useActivateClientUser,
  useDeactivateClientUser,
  useGetClientUser,
} from 'services/clientUserManagment';
import { IRegisterUserForm } from 'services/clientUserManagment/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { onErrorShowToast } from 'utils/service/errorHandler';

const EditClientUser = () => {
  const userId = useParamId('users');
  const { data: user, isLoading: isUserLoading } = useGetClientUser(userId);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const backPathname = `/client-users/${userId}`;
  const i18nextPrefix = 'user';
  const isLoading = isUserLoading;

  const activateUser = useActivateClientUser(userId);
  const deactivateUser = useDeactivateClientUser(userId);

  const enabelTwoFactor = useEnableTwoFactor(userId);
  const disableTwoFactor = useDisableTwoFactor(userId);

  const handleSubmit = async (
    values: IRegisterUserForm,
    formikHelpers: FormikHelpers<IRegisterUserForm>
  ) => {
    const { isActive, isTwoFactorEnabled } = values;

    // if (user?.isTwoFactorEnabled && !isTwoFactorEnabled) {
    //   await disableTwoFactor.mutateAsync(userId, {
    //     onError: (error: DefaultError) => {
    //       onErrorShowToast(error);
    //     },
    //     onSuccess: () => {
    //       navigate(`/client-users/${userId}`);
    //     },
    //   });
    // }

    // if (user?.isTwoFactorEnabled && isTwoFactorEnabled) {
    //   await enabelTwoFactor.mutateAsync(userId, {
    //     onError: (error: DefaultError) => {
    //       onErrorShowToast(error);
    //     },
    //     onSuccess: () => {
    //       navigate(`/client-users/${userId}`);
    //     },
    //   });
    // }

    if (user?.isActive && !isActive) {
      await deactivateUser.mutateAsync(undefined, {
        onError: (error: DefaultError) => {
          onErrorShowToast(error);
        },
        onSuccess: () => {
          navigate(`/client-users/${userId}`);
        },
      });
    }
    if (!user?.isActive && isActive) {
      await activateUser.mutateAsync(undefined, {
        onError: (error: DefaultError) => {
          onErrorShowToast(error);
        },
        onSuccess: () => {
          navigate(`/client-users/${userId}`);
        },
      });
    }

    if (
      user?.isActive === isActive ||
      user?.isTwoFactorEnabled === isTwoFactorEnabled
    ) {
      navigate(`/client-users/${userId}`);
    }
  };

  return (
    <Form.ClientUser
      i18nextPrefix={i18nextPrefix}
      tittle={user?.userName ?? t('user.title.individual')}
      initialValues={
        user ? middleware.clientUser.queryToForm(user) : userFormInitialValues
      }
      onSubmit={handleSubmit}
      disableTabs={[0]}
      backPath={backPathname}
      status={{ isLoading }}
      customBackItem={
        <Button
          onlyIcon
          onClick={() => {
            navigate(`${backPathname}`, { replace: true });
          }}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <div className='w-full flex justify-end items-center gap-8'>
          <Button type='submit' variant={BUTTON_VARIANT.submit}>
            <Button.Text text={t('button.save')} />
            <Button.Icon icon={<PiVinylRecord />} />
          </Button>
        </div>
      }
    />
  );
};

export default EditClientUser;
function mutateOptions(
  helpers: any
):
  | import('@tanstack/react-query').MutateOptions<
      import('services/userManagement/types').IGetPermissionsResponse,
      Error,
      import('services/userManagement/types').IUserPermissionQuery,
      unknown
    >
  | undefined {
  throw new Error('Function not implemented.');
}
